import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/useAuth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { PurchasesProvider } from "@/iap/PurchasesProvider";
import Index from "./pages/Index.tsx";
import Auth from "./pages/Auth.tsx";
import Connections from "./pages/Connections.tsx";
import AdminSetup from "./pages/AdminSetup.tsx";
import AdminDashboard from "./pages/AdminDashboard.tsx";
import NotFound from "./pages/NotFound.tsx";
import Privacy from "./pages/Privacy.tsx";
import Terms from "./pages/Terms.tsx";
import { lazy, Suspense, useEffect } from "react";
import { initAnalytics } from "@/lib/analytics";
const PushAdmin = lazy(() => import("./pages/admin/PushAdmin.tsx"));
const DeleteAccount = lazy(() => import("./pages/settings/DeleteAccount.tsx"));
const PermissionsOnboarding = lazy(() => import("./pages/mobile/PermissionsOnboarding.tsx"));

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => { void initAnalytics(); }, []);
  return (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AuthProvider>
            <PurchasesProvider>
            <Suspense fallback={null}>
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/onboarding/permissions" element={<PermissionsOnboarding />} />
              <Route path="/" element={<ProtectedRoute><Index /></ProtectedRoute>} />
              <Route path="/connections" element={<ProtectedRoute><Connections /></ProtectedRoute>} />
              <Route path="/admin/setup" element={<ProtectedRoute><AdminSetup /></ProtectedRoute>} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/push" element={<ProtectedRoute><PushAdmin /></ProtectedRoute>} />
              <Route path="/settings/delete-account" element={<ProtectedRoute><DeleteAccount /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            </Suspense>
            </PurchasesProvider>
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
  );
};

export default App;
